import Global from '../../js/constant.js'
import axios from 'axios'

const allAccounts = {
  state: {
    accounts: {},
  },
  getters: {
    accounts(state) { return state.accounts },
  },
  mutations: {
    setAllAccounts (state, value) {
      state.accounts = value
    },
  },
  actions: {
    getAllAccounts ({commit}) {
      return axios.post(Global.url.api_accounts_all, {})
      .then(res => {
        if (res.data.status === Global.api_status.success) {
          commit('setAllAccounts', res.data.accounts)
          return
        }
      })
      .catch(error=>{
        console.dir(error)
      })
    },
  },
  modules: {}
}
export default allAccounts